module.exports = __webpack_public_path__ + "img/gather_sleeve_ruffle.a7361663.png";